// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"CvDeleteConfirmationModal_buttonContainer__6tyBA","buttonSpace":"CvDeleteConfirmationModal_buttonSpace__3SYNP"};